import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const updateNewOrderAddress = {
  name: "updateNewOrderAddress" as const,
  input: z.object({
    returnId: zExt.objectId(),
    first_name: z.string(),
    last_name: z.string(),
    address1: z.string(),
    address2: z.string().optional(),
    city: z.string(),
    province_code: z.string().optional(),
    zip: z.string(),
    country_code: z.string(),
  }),
  output: z.null(),
};
